<div class="relative">
  @if (!menuIsOpened) {
    <button (click)="menuIsOpened = !menuIsOpened" [class]="containerClass" aria-label="Dropdown Menu">
      @if (text.length !== 0) {
        <div class="mr-2">
          {{text}}
        </div>
      }
      <fa-icon [icon]="icon"/>
    </button>
  }
  @if (menuIsOpened) {
    <button (click)="menuIsOpened = !menuIsOpened" [class]="clickedContainerClass" aria-label="Dropdown Menu">
      @if (text.length !== 0) {
        <div class="mr-2">
          {{text}}
        </div>
      }
      <fa-icon [icon]="icon"/>
    </button>
  }
  @if (menuIsOpened) {
    <div [class]="menuClass">
      @for (item of menuItems; track item) {
        @if (item.divider) {
          <div class="my-1 border-t border-[#D7D7D7]" role="separator"></div>
        }
        <button (click)="actionClick(item.route, item.queryParams, item.item_id, item.action)" [class]="item.danger ? dangerItemClass : itemClass">
          @if (item.icon) {
            <fa-icon [icon]="item.icon" class="mr-2 text-[#637381]"/>
          }
          {{item.title}}
        </button>
      }
    </div>
  }
</div>
